module.exports = __webpack_public_path__ + "img/insurance-icon.2097ba73.svg";